"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _SMSSettings = require("@/api/messagePush/SMSSettings");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      queryData: {
        phone: '',
        status: '',
        page: 1,
        size: 10
      }
    };
  },
  created: function created() {
    this.listTextMessageRecord();
  },
  methods: {
    listTextMessageRecord: function () {
      var _listTextMessageRecord2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.loading = true;
              params = (0, _objectSpread2.default)({}, this.queryData);
              _context.n = 1;
              return (0, _SMSSettings.listTextMessageRecord)(params);
            case 1:
              res = _context.v;
              this.loading = false;
              console.log('res', res);
              if (res.code === 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function listTextMessageRecord() {
        return _listTextMessageRecord2.apply(this, arguments);
      }
      return listTextMessageRecord;
    }(),
    onInquire: function onInquire() {
      this.queryData.page = 1;
      this.queryData.size = 10;
      this.listTextMessageRecord();
    },
    onInitialize: function onInitialize() {
      this.queryData = {
        phone: '',
        status: '',
        page: 1,
        size: 10
      };
      this.listTextMessageRecord();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryData.size = val;
      this.listTextMessageRecord();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.queryData.page = val;
      this.listTextMessageRecord();
    },
    onUserDetails: function onUserDetails(value) {
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: value.memberId,
          nickname: value.nickName
        }
      });
    },
    onReissue: function onReissue(id) {
      var _this = this;
      this.$confirm('确认重发此条短信?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.resendTextMessage(id);
      });
    },
    resendTextMessage: function () {
      var _resendTextMessage2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(id) {
        var params, res;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              params = {
                textMsgRecordId: id
              };
              _context2.n = 1;
              return (0, _SMSSettings.resendTextMessage)(params);
            case 1:
              res = _context2.v;
              console.log('res', res);
              if (res.code === 0) {
                this.$message.success('操作成功');
                this.listTextMessageRecord();
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function resendTextMessage(_x) {
        return _resendTextMessage2.apply(this, arguments);
      }
      return resendTextMessage;
    }()
  }
};